export default __webpack_public_path__ + "static/media/Girdle of Insanity.30f7e106.jpg";